<template>
    <v-bottom-sheet :value="showsRoom" persistent fullscreen>
        <v-card class="d-flex flex-column fill-height ma-0" tile>
            <v-card-title> 비대면면접 / {{ interview.title || "" }} </v-card-title>
            <v-card-text class="pb-0" style="flex-grow: 1">
                <v-row class="fill-height">
                    <v-col cols="9" style="position: relative">
                        <v-card color="black" class="fill-height pa-8" flat>
                            <room-videos />
                        </v-card>
                        <room-alerts />
                    </v-col>
                    <v-col cols="3" class="d-flex flex-column">
                        <room-self />
                        <room-participants class="mt-8" style="flex-grow: 1" />
                        <room-share />
                        <room-close />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-24">
                <room-actions />
            </v-card-actions>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import RoomActions from "./room/room-actions.vue";
import RoomAlerts from './room/room-alerts.vue';
import RoomClose from "./room/room-close.vue";
import RoomParticipants from "./room/room-participants.vue";
import RoomSelf from "./room/room-self.vue";
import RoomShare from "./room/room-share.vue";
import RoomVideos from "./room/room-videos.vue";

export default {
    components: {
        RoomActions,
        RoomClose,
        RoomParticipants,
        RoomSelf,
        RoomShare,
        RoomVideos,
        RoomAlerts,
    },
    computed: {
        ...mapGetters("interview", ["showsRoom"]),
        ...mapState("interview", { interview: (store) => store.data }),
    },
};
</script>

<style>
</style>